import { useCallback } from 'react';
import { Location, matchPath, useLocation, useNavigate, useParams } from 'react-router-dom';

import { WORKFLOW_ID_ROUTE_KEY } from '@/common/constants';

import { TUrlParams } from '../Types/UrlParams';

export const useSubNavigation = (to: string, deps = []) => {
  const { pathname } = useLocation();
  return useNavigation(`${pathname}/${to}`, deps);
};

export const useNavigation = (to: string, deps = []) => {
  const navigate = useNavigate();
  return useCallback(() => {
    navigate(to);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [to, ...deps]);
};

export const isMainRouteMatchForLocation = (
  to: string,
  paths: Record<
    string,
    {
      path: string;
      end: boolean;
    }
  > = {},
  location: Location
): boolean => {
  const targetPath = paths[to];
  const { pathname = '' } = location;
  const match = matchPath(targetPath, pathname);

  return !!match;
};

export const insertRouteKeyValue = (path: string, key: string, value: string) => {
  return path.replace(key, value);
};

export const insertWorkflowId = (path: string, value: string) => {
  return insertRouteKeyValue(path, WORKFLOW_ID_ROUTE_KEY, value);
};

export const withNestedRoutes = (path: string) => `${path}/*`;

export const useUrlParams = () => {
  const { workflowId, stepId, folderId, id } = useParams<TUrlParams>();

  return { workflowId, stepId, folderId, id };
};
